// removed by extract-text-webpack-plugin
module.exports = {"pwd":"index_pwd_2Olkh","pwdForm":"index_pwdForm_3VAw6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/personal/pwd/index.scss
// module id = 1555
// module chunks = 0